import {
    Grid,
    List,
    ListItem,
    ListItemText,
    Typography,
    Box,
    ListItemButton,
    Divider,
    Select,
    FormControl,
    MenuItem,
    ListItemIcon,
} from '@mui/material'
import moment from 'moment';
import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
/** @jsxImportSource @emotion/react */
import { jsx, css, keyframes } from "@emotion/react";
import { intlFormat } from 'date-fns';
import pr from "../lib/pr";
import get_token from "../lib/get_token";
import { configState } from '../lib/State';
import axios from 'axios';
import { ReactComponent as Star } from '../assets/push_star.svg';
import { ReactComponent as Megaphone } from '../assets/push_megaphone.svg';
import { ReactComponent as Reservation } from '../assets/push_reservation.svg';
import { ReactComponent as Frequency } from '../assets/push_frequency.svg';
import { ReactComponent as Ticket } from '../assets/push_ticket.svg';
import { ReactComponent as HeartRateIcon } from '../assets/heartrate02.svg';
import { ReactComponent as Coin } from '../assets/coin03.svg';
import get_cid from '../lib/get_cid';

function Notification(props) {

    const { login } = props;
    const [textAccordion, setTextAccordion] = useState([false]);
    const nowTime = moment().format('YYYY-MM-DD HH:mm');

    console.log(textAccordion)
    // const idNumber = useRef();

    const [id, setID] = useState();
    const [openState, setOpenState] = useState();
    const [rows, setRows] = useState([]);
    const [read, setRead] = useState(false);
    const [category, setCategory] = useState('전체')    // 알림 카테고리 item.title
    const cid = get_cid();

    const stretchedText = css`
        max-height: fit-content;
        height: fit-content;
        display: block;
        white-space: pre-wrap;
    `

    const firstHeight = css`
        height: 100px;
    `
    const secondHeight = css`
        height: fit-content;
    `

    const onOpenAccordianClick = (id) => {
        // 배열 변경
        const idx = rows.findIndex(el => el.id === id);
        setRows((state) => {
            let newState = state;
            newState[idx].open = !newState[idx].open; // 상태변경
            return [...newState];
        });
    }

    // [수정됨] rows 안에 open 변수로 처리합니다.
    // const idMap = rows.map((a)=> {
    //     return a.id;
    // });
    // console.log(idMap);

    // const onOpenAccordianClick = (event, index) => {
    // const onOpenAccordianClick = (id, open) => {

    //     pr(id);
    //     pr(open);
    //     pr(textAccordion);
    // setSelectedId(index)
    // if(textAccordion==false){
    //     setTextAccordion(true)
    // }
    // if(textAccordion==true){
    //     setTextAccordion(false);
    // }
    // const idMap = rows.map((a)=> {
    //     if(a.id==0&&textAccordion==false){
    //         setTextAccordion(true);
    //     }
    //     if(a.id!=0&&textAccordion==true){
    //         setTextAccordion(false);
    //     }
    //     console.log(a.id);
    // });
    // console.log(idMap);
    // alert(id);

    // setTextAccordion((state)=>{
    //     state[id] = !state[id];
    //     let newState = state;
    //     return [...newState];
    // }

    // alert(open);
    // setTextAccordion((state)=>{
    //     console.log(state[open]);
    //     // state[id] = !state[];
    //     // let newState = state;
    //     // return [...state, newState];
    // }
    // );        

    // if(id.textAccordion==false) {
    //     setTextAccordion(true);
    // }
    // if(id.textAccordion==true) {
    //     setTextAccordion(false);
    // }
    // console.log(rows);
    // if(textAccordion==false) {
    //     setTextAccordion(true);
    // }
    // if(textAccordion==true) {
    //     setTextAccordion(false);
    // }
    // }

    // LOAD DATA
    const load_data = async () => {
        const token = get_token();
        // const cid = cid;
        const mcd = login.mcd;
        const level = login.level;
        // pr(token);
        // pr(mcd);
        // pr(cid);
        // pr(level);
        let postData = {
            token: token,
            mcd: mcd,
            cid: cid,
            level: level,
        }
        let result = await axios.post(configState.api + "/gympass/my_push", postData);
        setRows(result.data.rows);
    }
    useEffect(() => {
        load_data();

    }, []);


    return (
        <Grid
            container
            height="100%"
            direction="column"
            marginTop='20px'>
            <Grid
                container
                flex="1"
                width="100%"
                height="auto"
                direction="column"
                alignItems="center">
                <FormControl
                    sx={{
                        width: '85%'
                    }}>
                    {/* <InputLabel></InputLabel> */}
                    <Select
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        // defaultValue='전체'
                        size='small'
                        variant='standard'>
                        <MenuItem value='전체'>전체</MenuItem>
                        <MenuItem value='공지'>공지</MenuItem>
                        <MenuItem value='이벤트'>이벤트</MenuItem>
                        <MenuItem value='쿠폰'>쿠폰</MenuItem>
                        <MenuItem value='예약'>예약</MenuItem>
                        <MenuItem value='심박'>심박</MenuItem>
                        <MenuItem value='캐시'>캐시</MenuItem>
                        <MenuItem value='출석'>출석</MenuItem>
                    </Select>
                </FormControl>
                <List
                    sx={{
                        width: '100%'
                    }}>
                    {rows.map((item, index) => {
                        return (
                            category === '전체' &&
                            <Box
                                key={index}
                            >
                                <ListItem
                                // key={index}
                                >
                                    <ListItemButton
                                        sx={{
                                            alignItems: 'flex-start'
                                        }}
                                        // selected={selectedId === 0}
                                        onClick={() => onOpenAccordianClick(item.id)}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                minWidth: '20px',
                                                marginRight: '10px',
                                                marginTop: '8px'
                                            }}>
                                            {item.title === '공지' && <Megaphone />}
                                            {item.title === '이벤트' && <Star />}
                                            {item.title === '쿠폰' && <Ticket />}
                                            {item.title === '예약' && <Reservation />}
                                            {item.title === '심박' && <HeartRateIcon />}
                                            {item.title === '캐시' && <Coin />}
                                            {item.title === '출석' && <Frequency />}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={

                                                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <Typography>
                                                        {item.title}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: '13px' }}>
                                                        {item.regdate}
                                                    </Typography>
                                                </Box>
                                            }
                                            secondary={

                                                <Box component={'span'} sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                    <Typography component={'span'} sx={{
                                                        width: '100%',
                                                        lineHeight: 1.2,
                                                        display: '-webkit-box',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'pre-wrap',
                                                        height: 'fit-content',
                                                        wordWrap: 'break-word',
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: 'vertical',
                                                    }}
                                                        css={
                                                            item.open === true ? stretchedText : null
                                                        }
                                                    >
                                                        {item.message}
                                                    </Typography>
                                                </Box>

                                            }
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <Divider variant='middle' />
                            </Box>
                            || category === item.title &&
                            <Box
                                key={index}
                            >
                                <ListItem
                                sx={{ width: '100%' }}
                                // key={index}
                                >
                                    <ListItemButton
                                        // selected={selectedId === 0}
                                        onClick={() => onOpenAccordianClick(item.id)}
                                        sx={{
                                            alignItems: 'flex-start'
                                        }}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                minWidth: '20px',
                                                marginRight: '10px',
                                                marginTop: '8px'
                                            }}>
                                            {item.title === '공지' && <Megaphone />}
                                            {item.title === '이벤트' && <Star />}
                                            {item.title === '쿠폰' && <Ticket />}
                                            {item.title === '예약' && <Reservation />}
                                            {item.title === '심박' && <HeartRateIcon />}
                                            {item.title === '캐시' && <Coin />}
                                            {item.title === '출석' && <Frequency />}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={

                                                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <Typography>
                                                        {item.title}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: '13px' }}>
                                                        {item.regdate}
                                                    </Typography>
                                                </Box>
                                            }
                                            secondary={

                                                <Box component={'span'} sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                    <Typography component={'span'} sx={{
                                                        width: '100%',
                                                        lineHeight: 1.2,
                                                        display: '-webkit-box',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'pre-wrap',
                                                        height: 'fit-content',
                                                        wordWrap: 'break-word',
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: 'vertical',
                                                    }}
                                                        css={
                                                            item.open === true ? stretchedText : null
                                                        }
                                                    >
                                                        {item.message}
                                                    </Typography>
                                                </Box>
                                            }
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <Divider variant='middle' />
                            </Box>
                        )
                    })}
                    { ((rows.filter((el) => el.title === category).length === 0 && category !== '전체') || rows.length === 0) &&
                        <ListItem>
                            <ListItemButton>
                                새로운 알림이 없습니다
                            </ListItemButton>
                        </ListItem>
                    }
                </List>
            </Grid>
        </Grid>
    )
}
export default Notification;